import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { EHeaderName } from '../../enums';
import { environment } from '../../../environments/environment';
import { isPublicEndpoint } from './public-endpoints';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  let headers = req.headers
    .set(EHeaderName.INS, environment.INS)
    .set(EHeaderName.DB, environment.DB)
    .set(EHeaderName.USER_PATH, environment.ADMIN_PATH);

  if (!isPublicEndpoint(req.url)) {
    // x-am-authorization (the platform API-user token) is required on every secured
    // request regardless of authProviders — confirmed against the platform's own
    // Request Headers Reference. x-am-user-authorization (DB-auth end-user token) is
    // the additional per-user identity on top of it. Sending only one and not the
    // other is what previously caused every write to 401 with "Authorization header
    // 'x-am-authorization' is not valid."
    const apiToken = auth.getApiToken();
    const accessToken = auth.getAccessToken();
    if (apiToken) headers = headers.set(EHeaderName.AUTHORIZATION_APP, apiToken);
    if (accessToken) headers = headers.set(EHeaderName.AUTHORIZATION_USER, accessToken);

    // x-caller-id (the current user's _id) — sent alongside the tokens so backend
    // handlers can resolve the caller without re-decoding the token, matching the
    // reference project's pattern (sava_printing_b2c_admin's authInterceptor).
    const userId = auth.user()?._id;
    if (userId) headers = headers.set(EHeaderName.CALLER_ID, userId);
  }

  return next(req.clone({ headers }));
};
